import type { SafetyProfilePayload } from "@miter/types/contracts";

import { ProfileSection } from "safety/components/profile/ProfileSection";

type ContactSectionProps = {
  contacts: NonNullable<SafetyProfilePayload["contacts"]>;
};

export const ContactSection = ({ contacts }: ContactSectionProps): React.JSX.Element => (
  <ProfileSection title="Get in touch">
    {contacts.map((contact, index) => (
      <div
        key={index}
        className="tw:flex tw:items-center tw:justify-between tw:gap-4 tw:border-b tw:border-stroke tw:px-4 tw:py-3 tw:last:border-b-0"
      >
        <span className="tw:min-w-0 tw:flex-1 tw:text-sm tw:text-midnight/75">{contact.label}</span>
        <a
          href={`mailto:${contact.email}`}
          className="tw:truncate tw:text-sm tw:font-medium tw:text-primary-purple tw:hover:underline"
        >
          {contact.email}
        </a>
      </div>
    ))}
  </ProfileSection>
);
